import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import AppleMusicIcon from '../../../assets/images/appleMusic-grey.svg';
import SpotifyIcon from '../../../assets/images/spotify-grey.svg';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { IAppStore } from '../../reducer';
import { orientationSelector } from '../../selectors';
import { changePlaylistPressed, selectMusicSourceButtonPress } from './actions';

interface IProps {
  selectMusicSourceButtonPress: () => void;
  changePlaylistPressed: () => void;
  orientation: string;
  t: (key: string, options?: any) => string;
}

const MusicPlayerHeaderNavigationComponent: FunctionComponent<IProps> = ({t, ...props}) => (
  <View style={[
    { flexDirection: 'row', alignItems: 'center' },
    props.orientation === 'PORTRAIT' && { justifyContent: 'space-evenly' },
    ]}>
    {
      props.orientation !== 'PORTRAIT' &&
      <View style={styles.verticalDivider}/>
    }
    <View style={styles.headerSection}>
      <TouchableOpacity onPress={props.changePlaylistPressed}>
        <Text style={[styles.headerLink, { color: Theme.PRIMARY }]}>{t('changePlaylist')}</Text>
      </TouchableOpacity>
    </View>
    <View style={styles.verticalDivider}/>
    <View style={styles.headerSection}>
      <TouchableOpacity onPress={props.selectMusicSourceButtonPress} style={{ flexDirection: 'row' }}>
        <SpotifyIcon width={defaultScale(20)} height={defaultScale(20)} style={{marginRight: defaultScale(5)}}/>
        <AppleMusicIcon width={defaultScale(20)} height={defaultScale(20)} style={{marginRight: defaultScale(8)}}/>
        <Text style={[styles.headerLink, { color: Theme.PRIMARY }]}>{t('changeMusicApp')}</Text>
      </TouchableOpacity>
    </View>
  </View>
);

const mapStateToProps = (state: IAppStore) => {
  return {
    orientation: orientationSelector(state),
  };
};

export const MusicPlayerHeaderNavigation = connect(mapStateToProps, {
  changePlaylistPressed,
  selectMusicSourceButtonPress,
})(MusicPlayerHeaderNavigationComponent);

const styles = StyleSheet.create({
  headerSection: {
    justifyContent: 'center',
    marginHorizontal: defaultScale(13),
  },
  verticalDivider: {
    height: defaultScale(30),
    backgroundColor: Theme.GREY_MEDIUM,
    width: defaultScale(1),
  },
  headerLink: {
    ...Theme.textStyle.bodyCopyReg,
  },
});
